import { Outlet } from "react-router-dom";

export default function TickerConfiguration() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
